export default "__VITE_ASSET__B3dkAv60__"